import React from "react";
import { HeroiconsOutlineCalendar } from "../../assets/icons/LayoutIcon";
import { DOCTOR, PRODUCTGROUP } from "../../constants/fetchData";

const EntryFormContent = ({
  formData,
  handleChange,
  handleSubmit,
  handleCancel,
}) => (
  <div className="flex flex-col h-full relative ">
    {/* Header area */}
    <div className="sticky top-0 bg-white z-10 pb-4 pt-6 w-full">
      <div className="flex justify-between items-center">
        <h1 className="text-text1 sm:text-3xl text-2xl font-bold">
          Add new entry
        </h1>
        <div className="hidden sm:block">
          <button
            onClick={handleSubmit}
            className="text-white bg-primary px-3.5 py-3 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
      <hr className="mt-5" />
    </div>
    <div className="flex-1 overflow-x-hidden pb-24 sm:pb-8">
      {/* Product Details Section */}
      <div className="text-text1 text-xl font-bold">
        <div className="grid grid-cols-1  gap-4 ">
          {/*  Date */}
          <div className="flex-1">
            <label htmlFor="date" className="primary_label">
              Date
            </label>
            <div className="relative mt-1">
              <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                <HeroiconsOutlineCalendar className="text-md text-gray-500" />
              </div>
              <div className="pl-10">
                <input
                  type="date"
                  id="date"
                  name="visitdate"
                  className="w-full custom-dateinput border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 bg-gray-50 appearance-none date-input-no-indicato cursor-not-allowed"
                  value={formData.visitdate}
                  onChange={handleChange}
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="grid gap-2 sm:flex">
            {/* Doctor name  Dropdown*/}
            <div className="flex-1 ">
              <label className="font-medium text-sm leading-5 text-text2">
                Doctor Name
              </label>
              <div className="primary-dropdown mt-1">
                <select
                  name="doctorsname"
                  className={`rounded px-1 text-sm font-normal uppercase focus:outline-none focus:ring-0 w-full ${
                    formData.doctorsname === "" ? "text-gray-400" : "text-text1"
                  } `}
                  value={formData.doctorsname}
                  onChange={handleChange}
                >
                  <option value="">Select Doctor</option>
                  {DOCTOR.map((doctor) => (
                    <option key={doctor.id} className="text-text1">
                      {doctor.Full_Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Product discussed   */}
            <div className="flex-1 ">
              <label className="font-medium text-sm leading-5 text-text2">
                Product Discussed
              </label>
              <div className="primary-dropdown mt-1">
                <select
                  name="product_discussed"
                  className={`rounded px-1 text-sm font-normal uppercase focus:outline-none focus:ring-0 w-full ${
                    formData.product_discussed === ""
                      ? "text-gray-400"
                      : "text-text1"
                  } `}
                  value={formData.product_discussed}
                  onChange={handleChange}
                >
                  <option value="">Select Product group</option>
                  {PRODUCTGROUP.map((product) => (
                    <option key={product.key} className="text-text1">
                      {product.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {/* Call Notes  */}
          <div className="flex-1">
            <label className="font-medium text-sm leading-5 text-text2">
              Call Notes
            </label>
            <textarea
              name="call_notes"
              placeholder="Enter your notes here..."
              className="primary_input text-text2 w-full border rounded-md mt-1 text-base font-normal"
              rows={4}
              value={formData.call_notes}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>

    {/* Fixed button container at the bottom for mobile */}
    <div className="block sm:hidden ">
      <div className=" absolute bottom-0 left-0 right-0 z-10 bg-white opacity-85 border-gray-200  flex justify-end py-2 gap-2">
        <button
          onClick={handleCancel}
          className="text-text1 bg-white border border-gray-300 px-3 py-2 rounded-md"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          className="text-white bg-primary px-3 py-2 rounded-md"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
);

export default EntryFormContent;
